import { useLayerStore } from "../state/useLayerStore";
import { LEVELS, type LevelSetting } from "../map/levels";
import { Choice } from "./ui/Field";

const OPTIONS: { value: LevelSetting; label: string }[] = [
  { value: "auto", label: "Auto" },
  ...LEVELS.map((l) => ({ value: l.id as LevelSetting, label: l.label })),
];

/**
 * Choose the geography prices are grouped over.
 *
 * "Auto" follows the zoom, which is what most people want most of the time.
 * Pinning a level matters when you are comparing whole cities but need to be
 * zoomed in far enough to see the streets.
 *
 * Lives in the sidebar header rather than in the Explore pane: this is the
 * unit every pane answers in — a click resolves to a department, a city or a
 * neighbourhood, and the scenario, hazard, climate and cost panes all read
 * that selection.
 */
export function LevelControl() {
  const setting = useLayerStore((s) => s.levelSetting);
  const setSetting = useLayerStore((s) => s.setLevelSetting);

  return (
    <div className="mt-2">
      <Choice
        label="Group by"
        value={setting}
        options={OPTIONS}
        onChange={setSetting}
      />
    </div>
  );
}
